import { render, staticRenderFns } from "./IdentityForm.vue?vue&type=template&id=17e665ea&"
import script from "./IdentityForm.vue?vue&type=script&lang=ts&"
export * from "./IdentityForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports